import { render, staticRenderFns } from "./RiceScore.vue?vue&type=template&id=2898d81a&scoped=true"
import script from "./RiceScore.vue?vue&type=script&lang=js"
export * from "./RiceScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898d81a",
  null
  
)

export default component.exports